import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input,Row,Col,Tree,message } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class SystemConfigPage extends Component {
  static propTypes = {
    systemconfig: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { systemConfigPage,currentSystemConfig} = this.props.systemconfig;
     const {getAllConfigType} = this.props.actions;
     getAllConfigType();
     this.fetchList( systemConfigPage);
  }

  fetchList = (page) => {
    const {getSystemConfigList} = this.props.actions;
    let params = Object.assign({},{page:page},{typeId:this.typeId,title:this.title})
    getSystemConfigList(params);
  }

  getDataSource() {
    const { systemconfig } = this.props;
    const { systemConfigById, systemConfigList } = systemconfig;
    if (!systemConfigList) return [];
    return systemConfigList.map(id => systemConfigById[id]);
  }

  get listProps() {
    const { systemconfig,actions } = this.props
    const { getSystemConfigListPending,systemConfigTotal,systemConfigPage } = systemconfig
    const { deleteSystemConfig,chooseCurrentSystemConfig,systemConfigModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getSystemConfigListPending,
      columns:[
        {
          title: "配置名",
          dataIndex: 'title',
          key: 'title',
          width: 180,
        },
        {
          title: "排序",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:systemConfigTotal,
        current:systemConfigPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentSystemConfig(record);
          systemConfigModalChange(true,"updata");
        }else if(item.key == 3){
            deleteSystemConfig(record.id).then((data) => {
            this.fetchList(systemConfigPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { systemconfig,actions } = this.props
    const { currentSystemConfig, systemConfigModalVisible,systemConfigPage, systemConfigModalType,submitSystemConfigPending,allConfigType } = systemconfig

    const { systemConfigModalChange,submitSystemConfig } = actions;
    const editItem  = systemConfigModalType === 'create' ? {} : currentSystemConfig
    return {
      item: systemConfigModalType === 'create' ? {} : currentSystemConfig,
      visible: systemConfigModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitSystemConfigPending,
      title: `${
        systemConfigModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "title",
          label: "配置项",
          initialValue: editItem.title,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        if (this.typeId == undefined){
            message.error("请先选择类别");
            return;
        }
        console.log(allConfigType[this.typeId]);
        console.log(data);
        submitSystemConfig(Object.assign({},data,{typeId:this.typeId,typeTag:allConfigType[this.typeId].typeTag})).then(data=> {
          systemConfigModalChange(false,"create");
          this.fetchList(systemConfigPage);
        })
      },
      onCancel() {
        systemConfigModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,systemconfig } = this.props
    const { currentSystemConfig,systemConfigPage} = systemconfig
    const { systemConfigModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "title",
            widget: Input,
            widgetProps:{
                placeholder:"请输入配置名"
            },
        },
      ],
      onFilterChange: value => {
          this.title = value.title;
         this.fetchList(1)
      },
      onAdd() {
        systemConfigModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,systemconfig } = this.props
    const { currentSystemConfig,systemConfigPage} = systemconfig
    const { systemConfigModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ 
                    if (this.typeId == undefined){
                        message.error("请先选择类别");
                        return;
                    }
                    systemConfigModalChange(true,'create')
                }
            }
        ]
    }
  }

  onSelect = (keys) => {

    if (keys.length > 0){
        this.typeId = keys[0];
        console.log(this.typeId)
    }else{
        this.typeId = undefined;
    }
    this.fetchList(1);
  }

  render() {
      const {systemconfig} = this.props;
      const {allConfigList,allConfigType} = systemconfig;
      let configTree = allConfigList.map(id => {
        const config = allConfigType[id];
        return {
            title:config.typeName,
            key:config.id,
        }
      })
      let newConfigTree = {
          key:-1,
          title:"类别",
          children:configTree,
      }
    return (
      <Page inner>
          <Row>
            <Col span={4}>
            <div style={{marginTop:6,paddingRight:10,borderWidth:1,borderColor:"#eee"}}>
                <div style={{fontSize:20}}>类别选择</div>
                <Tree
                    style={{paddingRight:30}}
                    treeData={newConfigTree}
                    onSelect={this.onSelect}
                >
                </Tree>
            </div>
            </Col>
            <Col span={20} >
            <CrudFilter {...this.filterProps} />
            <CrudButtons {...this.buttonProps} />
            <CrudTable {...this.listProps} />
            <CrudForm {...this.modalProps} />
            </Col>
        </Row>
       
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    systemconfig: state.systemconfig,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SystemConfigPage);


// WEBPACK FOOTER //
// ./src/features/systemconfig/SystemConfigPage.js